/* Pentola theme script: overlays, bag drawer, quick view, product form, gift options, search, filters. */
(() => {
  const P = window.Pentola || {};
  const S = P.strings || {};
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const isDesk = () => matchMedia('(min-width: 990px)').matches;
  const parse = (html) => new DOMParser().parseFromString(html, 'text/html');
  const esc = (s) => String(s ?? '').replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  const store = {
    get(k, d) { try { const v = localStorage.getItem(k); return v ? JSON.parse(v) : d; } catch (e) { return d; } },
    set(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} },
  };

  /* ---------- money (Shopify money_format, 3 decimals for KWD and friends) ---------- */
  // Shopify amounts always carry two decimals; stores showing three (KWD) add the extra digit in the money format itself.
  function money(cents) {
    const fmt = P.money || '{{amount}}';
    const dec = 2;
    const n = (Number(cents) || 0) / 100;
    const group = (x, d, th, dp) => { const [a, b] = x.toFixed(d).split('.'); return a.replace(/\B(?=(\d{3})+(?!\d))/g, th) + (b ? dp + b : ''); };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (m, k) => {
      if (k === 'amount_no_decimals') return group(n, 0, ',', '.');
      if (k === 'amount_with_comma_separator') return group(n, dec, '.', ',');
      if (k === 'amount_no_decimals_with_comma_separator') return group(n, 0, '.', ',');
      return group(n, dec, ',', '.');
    });
  }
  P.formatMoney = money;

  /* ---------- overlays ---------- */
  const scrim = $('[data-p-scrim]');
  let openEl = null, lastFocus = null;
  function openOverlay(el, from) {
    if (!el) return;
    if (openEl && openEl !== el) closeOverlay(true);
    lastFocus = from || document.activeElement;
    el.classList.add('is-open');
    scrim && scrim.classList.add('is-on');
    document.body.classList.add('p-lock');
    openEl = el;
    el.setAttribute('tabindex', '-1');
    setTimeout(() => { const f = el.querySelector('[data-p-autofocus]') || el; f.focus({ preventScroll: true }); }, 80);
    const t = $('#PToast'); t && t.classList.remove('is-on');
  }
  function closeOverlay(silent) {
    if (!openEl) return;
    openEl.classList.remove('is-open');
    scrim && scrim.classList.remove('is-on');
    document.body.classList.remove('p-lock');
    openEl = null;
    if (!silent && lastFocus && document.contains(lastFocus)) lastFocus.focus({ preventScroll: true });
  }
  scrim && scrim.addEventListener('click', () => closeOverlay());

  // touch screens draw their own grey scroll bar and won't let it be styled, so open panels draw an olive one
  if (matchMedia('(pointer: coarse)').matches) {
    const bar = document.createElement('div');
    bar.className = 'p-srail'; bar.setAttribute('aria-hidden', 'true'); bar.innerHTML = '<i></i>';
    document.body.appendChild(bar);
    const knob = bar.firstChild;
    let box = null, frame = 0, idle;
    const draw = () => {
      frame = 0;
      const max = box.scrollHeight - box.clientHeight, r = box.getBoundingClientRect();
      if (max < 8 || r.height < 60) { bar.classList.remove('is-on'); return; }
      const h = r.height - 16, k = Math.max(28, (h * box.clientHeight) / box.scrollHeight);
      bar.style.transform = `translate(${r.right - 7}px, ${r.top + 8}px)`;
      bar.style.height = `${h}px`;
      knob.style.height = `${k}px`;
      knob.style.transform = `translateY(${(h - k) * Math.min(1, Math.max(0, box.scrollTop / max))}px)`;
      bar.classList.add('is-on');
      clearTimeout(idle);
      idle = setTimeout(() => bar.classList.remove('is-on'), 900);
    };
    document.addEventListener('scroll', (e) => {
      if (!(e.target instanceof Element) || !e.target.closest('.is-open')) return;
      box = e.target;
      frame = frame || requestAnimationFrame(draw);
    }, { capture: true, passive: true });
  }
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    closeOverlay(); closeMega();
  });
  // keep keyboard focus inside an open overlay
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Tab' || !openEl) return;
    const f = $$('a[href], button:not([disabled]), input:not([type=hidden]), textarea, select, [tabindex]:not([tabindex="-1"])', openEl).filter((x) => x.offsetParent !== null);
    if (!f.length) return;
    const first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });
  document.addEventListener('click', (e) => {
    const o = e.target.closest('[data-p-open]');
    if (o) {
      e.preventDefault();
      const k = o.dataset.pOpen;
      if (k === 'cart') return PentolaCart.open(o);
      if (k === 'search') { openOverlay($('#PSearch'), o); setTimeout(() => $('#PSearchInput') && $('#PSearchInput').focus(), 120); return; }
      if (k === 'sheet') { const sh = $('#PSheet'); if (sh) { selectTab(sh, o.dataset.pTab || sh.dataset.pDefault || null); openOverlay(sh, o); } return; }
    }
    if (e.target.closest('[data-p-close]')) { e.preventDefault(); closeOverlay(); }
    const q = e.target.closest('[data-p-qv]');
    if (q) { e.preventDefault(); QuickView.open(q.dataset.pQv, q); }
  });

  /* ---------- toast ---------- */
  let toastT;
  function toast({ image, title, sub }) {
    const el = $('#PToast'); if (!el) return;
    el.innerHTML = `${image ? `<span class="p-frame"><img src="${esc(image)}" alt="" width="46" height="46"></span>` : '<span></span>'}<div><span class="p-lbl">${esc(S.addedTo)}</span><b>${esc(title)}</b>${sub ? `<span>${esc(sub)}</span>` : ''}</div><button type="button" data-p-open="cart">${esc(S.viewBag)}</button>`;
    el.classList.add('is-on');
    clearTimeout(toastT); toastT = setTimeout(() => el.classList.remove('is-on'), 4200);
  }
  const toastEl = $('#PToast');
  if (toastEl) {
    toastEl.addEventListener('mouseenter', () => clearTimeout(toastT));
    toastEl.addEventListener('mouseleave', () => { toastT = setTimeout(() => toastEl.classList.remove('is-on'), 1600); });
  }

  /* ---------- bag ---------- */
  const DRAWER = 'pentola-cart-drawer';
  const PentolaCart = {
    get el() { return $('#PCart'); },
    open(from) { this.refresh().then(() => openOverlay(this.el, from)); },
    close() { closeOverlay(); },
    swap(html) {
      if (!html) return;
      const fresh = parse(html).querySelector('#PCart');
      const cur = this.el;
      if (fresh && cur) {
        const wasOpen = cur.classList.contains('is-open');
        const top = ($('.p-db', cur) || {}).scrollTop || 0;
        cur.innerHTML = fresh.innerHTML;
        if (wasOpen) cur.classList.add('is-open');
        const db = $('.p-db', cur); if (db) db.scrollTop = top;
        this.count(+fresh.dataset.count || 0);
      }
    },
    count(n) { $$('[data-p-count]').forEach((e) => (e.textContent = n > 0 ? n : '')); },
    async refresh() {
      try { const r = await fetch(`${P.routes.root}?section_id=${DRAWER}`); if (r.ok) this.swap(await r.text()); } catch (e) {}
    },
    async add(items, { button, notice } = {}) {
      if (button) { button.classList.add('is-busy'); button.dataset.l = button.innerHTML; button.textContent = S.adding; }
      try {
        const r = await fetch(`${P.routes.add}.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items, sections: DRAWER, sections_url: location.pathname }) });
        const data = await r.json();
        if (!r.ok || data.status) throw new Error(data.description || data.message || S.error);
        // the item is in the bag now; a failed redraw only means fetching the drawer again
        if (data.sections && data.sections[DRAWER]) this.swap(data.sections[DRAWER]); else await this.refresh();
        if (notice) toast(notice);
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'pentola' });
        return true;
      } catch (err) {
        toastError(err.message);
        return false;
      } finally {
        if (button) { button.classList.remove('is-busy'); button.innerHTML = button.dataset.l; }
      }
    },
    async change(line, quantity) {
      const cur = this.el; cur && cur.classList.add('is-busy');
      try {
        const r = await fetch(`${P.routes.change}.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line, quantity, sections: DRAWER, sections_url: location.pathname }) });
        const data = await r.json();
        if (!r.ok || data.status) throw new Error(data.description || data.message || S.error);
        this.swap(data.sections && data.sections[DRAWER]);
      } catch (err) { await this.refresh(); toastError(err.message); }
      finally { cur && cur.classList.remove('is-busy'); }
    },
    note: null,
    saveNote(v) {
      clearTimeout(this.note);
      this.note = setTimeout(() => fetch(`${P.routes.update}.js`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: v }) }), 500);
    },
  };
  window.PentolaCart = PentolaCart;
  function toastError(msg) {
    const el = $('#PToast'); if (!el) return;
    el.innerHTML = `<span></span><div><span class="p-lbl">${esc(S.error)}</span><b>${esc(msg || '')}</b></div><span></span>`;
    el.classList.add('is-on'); clearTimeout(toastT); toastT = setTimeout(() => el.classList.remove('is-on'), 5000);
  }
  document.addEventListener('click', (e) => {
    const q = e.target.closest('[data-p-line]');
    if (q) { e.preventDefault(); PentolaCart.change(+q.dataset.pLine, +q.dataset.pQty); }
    const all = e.target.closest('[data-p-addall]');
    if (all && !all.disabled) {
      e.preventDefault();
      const ids = JSON.parse(all.dataset.pAddall || '[]');
      PentolaCart.add(ids.map((id) => ({ id, quantity: 1 })), { button: all, notice: { title: all.dataset.pTitle, sub: all.dataset.pSub, image: all.dataset.pImage } });
    }
  });
  document.addEventListener('change', (e) => {
    if (e.target.matches('[data-p-note-toggle]')) { const t = $('[data-p-note]', PentolaCart.el); if (t) { t.hidden = !e.target.checked; if (!e.target.checked) { t.value = ''; PentolaCart.saveNote(''); } } }
  });
  document.addEventListener('input', (e) => { if (e.target.matches('[data-p-note]')) PentolaCart.saveNote(e.target.value); });
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.cartUpdate, (ev) => { if (!ev || ev.source !== 'pentola') PentolaCart.refresh(); });

  /* ---------- header: sticky line, clear over the hero, mega menus, announcement ---------- */
  const hdr = $('.p-hdr');
  const hero = $('[data-p-hero]');
  if (hero && hero.closest('.shopify-section') === $('#MainContent .shopify-section')) document.body.classList.add('p-has-hero');
  function onScroll() {
    const y = scrollY;
    if (hdr) hdr.classList.toggle('is-lined', y > 40);
    document.body.classList.toggle('p-clear', document.body.classList.contains('p-has-hero') && !!hero && y < hero.offsetHeight - 90);
  }
  let tick = false;
  addEventListener('scroll', () => { if (!tick) { tick = true; requestAnimationFrame(() => { onScroll(); tick = false; }); } }, { passive: true });
  onScroll();

  let megaT;
  function openMega(k) {
    clearTimeout(megaT);
    $$('.p-mega').forEach((m) => m.classList.toggle('is-on', m.dataset.pPanel === k));
    $$('[data-p-mega]').forEach((b) => { const on = b.dataset.pMega === k; b.classList.toggle('is-on', on); b.setAttribute('aria-expanded', on); });
    hdr && hdr.classList.add('is-mega');
  }
  function closeMega() {
    $$('.p-mega').forEach((m) => m.classList.remove('is-on'));
    $$('[data-p-mega]').forEach((b) => { b.classList.remove('is-on'); b.setAttribute('aria-expanded', 'false'); });
    hdr && hdr.classList.remove('is-mega');
  }
  $$('[data-p-mega]').forEach((b) => {
    b.addEventListener('mouseenter', () => openMega(b.dataset.pMega));
    b.addEventListener('click', () => (b.classList.contains('is-on') ? closeMega() : openMega(b.dataset.pMega)));
  });
  const megaZone = $('[data-p-megazone]');
  if (megaZone) {
    megaZone.addEventListener('mouseleave', () => (megaT = setTimeout(closeMega, 220)));
    megaZone.addEventListener('mouseenter', () => clearTimeout(megaT));
  }

  $$('[data-p-ann]').forEach((ann) => {
    const items = $$('.p-ann__i', ann);
    if (items.length < 2 || reduced) return;
    let i = 0;
    setInterval(() => { items[i].classList.remove('is-on'); i = (i + 1) % items.length; items[i].classList.add('is-on'); }, (+ann.dataset.pAnn || 4.5) * 1000);
  });

  /* news bar: repeat the messages until they fill the width, then drift the doubled line by half its length forever */
  function newsBar(bar) {
    if (reduced) return;
    const track = $('.p-tick__track', bar), run = $('.p-tick__run', bar);
    if (!run) return;
    bar.pSet = bar.pSet || [...run.children];
    if (!bar.pSet.length) return;
    bar.classList.remove('is-on');
    $$('.p-tick__run', track).slice(1).forEach((r) => r.remove());
    run.replaceChildren(...bar.pSet);
    bar.classList.add('is-on');
    const one = run.getBoundingClientRect().width;
    if (!one) return;
    const copy = (el) => { const c = el.cloneNode(true); c.setAttribute('aria-hidden', 'true'); c.removeAttribute('data-shopify-editor-block'); if (c.matches('a')) c.tabIndex = -1; return c; };
    for (let i = 1; i < Math.ceil(bar.clientWidth / one); i++) bar.pSet.forEach((el) => run.appendChild(copy(el)));
    track.appendChild(copy(run));
    bar.style.setProperty('--p-tick-d', `${run.getBoundingClientRect().width / (+bar.dataset.pTick || 40)}s`);
    bar.pW = bar.clientWidth;
    if (!bar.pIo && 'IntersectionObserver' in window) (bar.pIo = new IntersectionObserver(([en]) => bar.classList.toggle('is-off', !en.isIntersecting))).observe(bar);
  }
  const newsBars = () => $$('[data-p-tick]').forEach(newsBar);
  newsBars();
  if (document.fonts) document.fonts.ready.then(newsBars);
  let newsT;
  addEventListener('resize', () => { clearTimeout(newsT); newsT = setTimeout(() => $$('[data-p-tick]').forEach((b) => b.clientWidth !== b.pW && newsBar(b)), 200); });

  /* menu sheet tabs */
  function selectTab(sheet, key) {
    const tabs = $$('[role=tab]', sheet);
    if (!tabs.length) return;
    const tab = tabs.find((t) => t.dataset.pTabKey === key) || tabs[0];
    tabs.forEach((t) => { const on = t === tab; t.setAttribute('aria-selected', on); t.tabIndex = on ? 0 : -1; const p = $('#' + t.getAttribute('aria-controls')); if (p) p.hidden = !on; });
  }
  document.addEventListener('click', (e) => { const t = e.target.closest('.p-sheet [role=tab]'); if (t) selectTab(t.closest('.p-sheet'), t.dataset.pTabKey); });

  /* ---------- hero film ---------- */
  $$('[data-p-hero]').forEach((h) => {
    const btn = $('[data-p-pp]', h);
    const vids = $$('video', h);
    const setState = (paused) => {
      h.classList.toggle('is-paused', paused);
      vids.forEach((v) => (paused ? v.pause() : v.play().catch(() => {})));
      if (btn) { btn.innerHTML = paused ? btn.dataset.play : btn.dataset.pause; btn.setAttribute('aria-label', paused ? btn.dataset.playLabel : btn.dataset.pauseLabel); }
    };
    if (reduced) setState(true);
    btn && btn.addEventListener('click', () => setState(!h.classList.contains('is-paused')));
  });

  /* ---------- reveal ---------- */
  const rio = 'IntersectionObserver' in window ? new IntersectionObserver((es) => es.forEach((en) => { if (en.isIntersecting) { en.target.classList.add('is-in'); rio.unobserve(en.target); } }), { rootMargin: '0px 0px -6% 0px' }) : null;
  const reveal = (root = document) => $$('.p-rv:not(.is-in)', root).forEach((el) => (rio ? rio.observe(el) : el.classList.add('is-in')));
  reveal();

  /* collection index preview */
  document.addEventListener('mouseover', (e) => {
    const a = e.target.closest('[data-p-ci]'); if (!a) return;
    const box = a.closest('[data-p-cindex]'); if (!box) return;
    $$('[data-p-cimg]', box).forEach((m) => m.classList.toggle('is-on', m.dataset.pCimg === a.dataset.pCi));
  });

  /* ---------- description: Pentola's own words, laid out ---------- */
  function formatDescription(root) {
    if (!root || root.dataset.pDone) return;
    const src = root.innerHTML;
    const text = src
      .replace(/<li[^>]*>/gi, '\n• ').replace(/<\/li>/gi, '\n')
      .replace(/<br\s*\/?>/gi, '\n').replace(/<\/(p|div|h\d|ul|ol)>/gi, '\n')
      .replace(/<[^>]+>/g, '');
    const tmp = document.createElement('textarea'); tmp.innerHTML = text;
    const lines = tmp.value.split('\n').map((l) => l.replace(/\s+/g, ' ').trim()).filter(Boolean);
    const blocks = [];
    const push = (type, val) => {
      const last = blocks[blocks.length - 1];
      if (type === 'li') { if (last && last.type === 'ul') last.items.push(val); else blocks.push({ type: 'ul', items: [val] }); }
      else if (type === 'spec') { if (last && last.type === 'dl') last.rows.push(val); else blocks.push({ type: 'dl', rows: [val] }); }
      else blocks.push({ type, text: val });
    };
    for (const l of lines) {
      if (/[؀-ۿ]/.test(l)) continue; // Arabic lines wait for the Arabic store
      const last = blocks[blocks.length - 1];
      if (/^\(.*\)$/.test(l) && last && last.type === 'dl') { last.rows[last.rows.length - 1].note = l.slice(1, -1); continue; }
      if (/^\*/.test(l)) { push('note', l.replace(/^\*+\s*/, '')); continue; }
      if (/^[•·\-–]\s*\S/.test(l)) { push('li', l.replace(/^[•·\-–]\s*/, '')); continue; }
      if (/^[^.:]{2,28}:$/.test(l)) { push('h', l.slice(0, -1).trim()); continue; }
      const m = l.match(/^([A-Za-z][A-Za-z ()/&-]{1,26}):\s*(.+)$/);
      if (m) { push('spec', { k: m[1].trim().replace(/^Dimension$/, 'Dimensions'), v: m[2].trim() }); continue; }
      push('p', l);
    }
    if (!blocks.length) return;
    root.innerHTML = blocks.map((b) => {
      if (b.type === 'p') return `<p>${esc(b.text)}</p>`;
      if (b.type === 'h') return `<h4>${esc(b.text)}</h4>`;
      if (b.type === 'note') return `<p class="p-note">${esc(b.text)}</p>`;
      if (b.type === 'ul') return `<ul>${b.items.map((i) => `<li>${esc(i)}</li>`).join('')}</ul>`;
      return `<dl>${b.rows.map((r) => `<div><dt>${esc(r.k)}</dt><dd>${esc(r.v)}${r.note ? ` <span>(${esc(r.note)})</span>` : ''}</dd></div>`).join('')}</dl>`;
    }).join('');
    root.dataset.pDone = '1';
  }
  const preorderNote = (root) => { const m = (root ? root.textContent : '').match(/Orders?'?s? take[^.]*\./i); return m ? m[0] : ''; };

  /* ---------- product form (product page + quick view) ---------- */
  class Product {
    constructor(root) {
      this.root = root;
      this.data = JSON.parse(($('[data-p-json]', root) || {}).textContent || '{}');
      this.variants = this.data.variants || [];
      this.isPage = root.dataset.pContext === 'page';
      this.form = $('[data-p-form]', root);
      this.idInput = this.form && $('input[name=id]', this.form);
      this.sel = (this.data.options || []).map((o, i) => { const on = $(`[data-p-opt="${i}"].is-on`, root); return on ? on.dataset.pVal : null; });
      this.bind();
      formatDescription($('[data-p-desc]', root));
      const pn = preorderNote($('[data-p-desc]', root)); if (pn) this.preNote = pn;
      this.update(false);
      if (this.isPage) { this.gallery(); this.sticky(); this.remember(); }
    }
    get variant() {
      if (!this.data.options || !this.data.options.length || this.variants.length === 1) return this.variants[0];
      if (this.sel.some((x) => x == null)) return null;
      return this.variants.find((v) => v.options.every((x, i) => x === this.sel[i])) || null;
    }
    ok(i, val) { return this.variants.some((v) => v.available && v.options[i] === val && v.options.every((x, j) => j === i || this.sel[j] == null || x === this.sel[j])); }
    bind() {
      this.root.addEventListener('click', (e) => {
        const o = e.target.closest('[data-p-opt]');
        if (o) { e.preventDefault(); this.sel[+o.dataset.pOpt] = o.dataset.pVal; this.update(true); }
        const q = e.target.closest('[data-p-step]');
        if (q) { e.preventDefault(); const inp = $('[data-p-qty]', this.root); inp.value = Math.max(1, (+inp.value || 1) + +q.dataset.pStep); this.update(false); }
        const fam = e.target.closest('[data-p-fam]');
        if (fam && !this.isPage) { e.preventDefault(); QuickView.open(fam.getAttribute('href'), null, true); }
        const wa = e.target.closest('[data-p-wa-piece]');
        if (wa) this.waLink(wa);
        const lang = e.target.closest('[data-p-lang]');
        if (lang) { e.preventDefault(); $$('[data-p-lang]', this.root).forEach((b) => { b.classList.toggle('is-on', b === lang); b.setAttribute('aria-pressed', b === lang); }); const ta = $('[data-p-gift-msg]', this.root); if (ta) { ta.dir = lang.dataset.pLang === 'ar' ? 'rtl' : 'ltr'; ta.placeholder = lang.dataset.pPlaceholder; } }
      });
      this.root.addEventListener('change', (e) => {
        if (e.target.matches('[data-p-gift-on]')) $('[data-p-gift]', this.root).classList.toggle('is-on', e.target.checked);
        if (e.target.matches('[data-p-qty]')) this.update(false);
      });
      this.form && this.form.addEventListener('submit', (e) => { e.preventDefault(); this.add(e.submitter || $('[data-p-add]', this.root)); });
    }
    update(userChange) {
      const v = this.variant, r = this.root, opts = this.data.options || [];
      opts.forEach((o, i) => {
        $$(`[data-p-opt="${i}"]`, r).forEach((b) => {
          const on = this.sel[i] === b.dataset.pVal;
          b.classList.toggle('is-on', on); b.setAttribute('aria-checked', on);
          b.classList.toggle('is-na', !this.ok(i, b.dataset.pVal));
        });
        const lab = $(`[data-p-opt-label="${i}"]`, r); if (lab) lab.textContent = this.sel[i] || S.chooseShort;
      });
      if (this.idInput) this.idInput.value = v ? v.id : '';
      const qty = +(($('[data-p-qty]', r) || {}).value || 1);
      const price = $('[data-p-price]', r);
      const cut = v && v.compare_at_price > v.price ? Math.round(((v.compare_at_price - v.price) * 100) / v.compare_at_price) : 0;
      if (price) price.innerHTML = v ? `<span>${money(v.price)}</span>${cut ? `<s>${money(v.compare_at_price)}</s>${S.sale ? `<em class="p-off">${esc(S.sale.replace('[percent]', cut))}</em>` : ''}` : ''}` : `<span>${money(this.data.price_min || 0)}</span>`;
      const add = $('[data-p-add]', r), pre = !!this.data.preorder;
      let label, off = true, short;
      if (!v) { const miss = opts.findIndex((o, i) => this.sel[i] == null); label = S.choose.replace('[option]', (opts[miss] || {}).name || ''); short = S.chooseShort; }
      else if (!v.available) { label = short = S.soldOut; }
      else { off = false; short = pre ? S.preOrder : S.addToBag; label = `${short} <span class="p-x">· ${money(v.price * qty)}</span>`; }
      if (add && !add.classList.contains('is-busy')) { add.innerHTML = label; add.disabled = off; }
      const buyNow = $('[data-p-buynow]', r); if (buyNow) buyNow.hidden = off;
      const st = $('[data-p-state]', r);
      if (st) {
        st.className = 'p-state' + (v && !v.available ? ' is-out' : pre ? ' is-pre' : '');
        st.innerHTML = `<i></i><span>${!v ? esc(S.chooseToCheck) : !v.available ? esc(S.soldOutNotify) : pre ? esc(S.preOrder + '. ' + (this.preNote || '')) : esc(S.inStock)}</span>`;
      }
      const nf = $('[data-p-notify]', r); if (nf) nf.hidden = !(v && !v.available);
      const nfBody = $('[data-p-notify-body]', r); if (nfBody) nfBody.value = `Notify me when back: ${this.data.title}${v && v.title !== 'Default Title' ? ' – ' + v.title : ''}`;
      if (userChange && v && v.featured_media) this.showMedia(v.featured_media.id);
      if (userChange && this.isPage && v) { const u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u); }
      this.paintSticky();
    }
    waLink(a) {
      const v = this.variant;
      const text = `${P.whatsappGreeting || ''} ${this.data.title}${v && v.title !== 'Default Title' ? ' (' + v.title + ')' : ''}.\n${location.origin}${this.data.url}`;
      if (P.whatsapp) a.href = `https://wa.me/${P.whatsapp}?text=${encodeURIComponent(text.trim())}`;
    }
    giftItems(main) {
      const box = $('[data-p-gift]', this.root);
      if (!box || !$('[data-p-gift-on]', box).checked) return [];
      const msg = ($('[data-p-gift-msg]', box) || {}).value || '';
      const langBtn = $('[data-p-lang].is-on', box);
      const to = ($('[data-p-gift-to]', box) || {}).value || '';
      const phone = ($('[data-p-gift-phone]', box) || {}).value || '';
      const date = ($('[data-p-gift-date]', box) || {}).value || '';
      const props = { For: this.data.title };
      if (msg.trim()) props['Gift message'] = msg.trim();
      if (langBtn && msg.trim()) props['Card language'] = langBtn.dataset.pLangName;
      if (to.trim()) props['Recipient'] = to.trim();
      if (phone.trim()) props['Recipient phone'] = phone.trim();
      if (date) props['Delivery date'] = date;
      const chosen = $$('[data-p-gift-id]:checked', box).map((c) => ({ id: +c.dataset.pGiftId, quantity: 1, properties: props }));
      if (!chosen.length && (msg.trim() || to.trim())) main.properties = Object.assign(main.properties || {}, props);
      return chosen;
    }
    async add(btn) {
      const v = this.variant; if (!v || !v.available) return;
      const qty = Math.max(1, +(($('[data-p-qty]', this.root) || {}).value || 1));
      const main = { id: v.id, quantity: qty };
      const extras = this.giftItems(main);
      const img = (v.featured_image && v.featured_image.src) || this.data.image;
      const ok = await PentolaCart.add([main, ...extras], { button: btn, notice: { title: this.data.title, sub: [v.title !== 'Default Title' ? v.title : '', extras.length ? S.asGift : ''].filter(Boolean).join(' · '), image: img ? img + (img.includes('?') ? '&' : '?') + 'width=120' : '' } });
      if (ok && !this.isPage) closeOverlay(true);
    }
    gallery() {
      const t = $('[data-p-track]', this.root); if (!t) return;
      const n = $('[data-p-gcount]', this.root);
      t.addEventListener('scroll', () => {
        if (isDesk()) return;
        const i = Math.round(t.scrollLeft / t.clientWidth);
        if (n) n.textContent = `${i + 1} / ${t.children.length}`;
        $$('[data-p-thumb]', this.root).forEach((b, j) => b.classList.toggle('is-on', j === i));
      }, { passive: true });
      this.root.addEventListener('click', (e) => { const b = e.target.closest('[data-p-thumb]'); if (b) { e.preventDefault(); this.showMedia(b.dataset.pThumb); } });
    }
    showMedia(id) {
      const item = $(`[data-p-media="${id}"]`, this.root); if (!item) return;
      const t = item.parentElement;
      $$('[data-p-thumb]', this.root).forEach((b) => b.classList.toggle('is-on', b.dataset.pThumb == id));
      if (isDesk() && this.isPage) window.scrollTo({ top: item.getBoundingClientRect().top + scrollY - 100, behavior: reduced ? 'auto' : 'smooth' });
      else t.scrollTo({ left: item.offsetLeft - t.offsetLeft, behavior: reduced ? 'auto' : 'smooth' });
    }
    sticky() {
      const bar = $('[data-p-sbar]'), add = $('[data-p-add]', this.root);
      if (!bar || !add || !P.stickyBar) return;
      this.bar = bar;
      new IntersectionObserver(([en]) => { const past = !en.isIntersecting && en.boundingClientRect.top < 0; bar.classList.toggle('is-on', past); bar.setAttribute('aria-hidden', !past); }).observe(add);
      bar.addEventListener('click', (e) => {
        const b = e.target.closest('[data-p-sadd]'); if (!b) return;
        if (b.disabled || !this.variant) { $('.p-opt', this.root) && $('.p-opt', this.root).scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
        this.add(b);
      });
      this.paintSticky();
    }
    paintSticky() {
      if (!this.bar) return;
      const v = this.variant, add = $('[data-p-sadd]', this.bar), sub = $('[data-p-ssub]', this.bar);
      if (sub) sub.textContent = v ? [v.title !== 'Default Title' ? v.title : '', money(v.price)].filter(Boolean).join(' · ') : S.chooseShort;
      if (add) { add.disabled = !v || !v.available; add.textContent = !v ? S.chooseShort : !v.available ? S.soldOut : this.data.preorder ? S.preOrder : S.addToBag; if (!v) add.disabled = false; }
    }
    remember() {
      if (!P.recentlyViewed || !this.data.handle) return;
      const list = store.get('pentola-recent', []).filter((x) => x.h !== this.data.handle);
      list.unshift({ h: this.data.handle, u: this.data.url, t: this.data.title, p: money(this.data.price_min), i: this.data.image ? this.data.image + (this.data.image.includes('?') ? '&' : '?') + 'width=540' : '' });
      store.set('pentola-recent', list.slice(0, 12));
    }
  }
  $$('[data-p-product]').forEach((r) => new Product(r));

  /* ---------- set builder: the size once, then a colour for each piece, added in one go ---------- */
  const cap = (s) => String(s).charAt(0).toUpperCase() + String(s).slice(1);
  class SetBuilder {
    constructor(card) {
      this.card = card; this.l = card.dataset;
      this.root = card.closest('[data-p-product]');
      this.data = JSON.parse(($('[data-p-json]', this.root) || {}).textContent || '{}');
      this.vs = this.data.variants || [];
      this.n = +this.l.n || 6; this.pct = +this.l.pct || 0;
      const names = (this.data.options || []).map((o) => o.name);
      this.pi = names.findIndex((x) => /^colou?rs?$/i.test(String(x).trim()));
      if (this.pi < 0) this.pi = Math.max(0, names.length - 1);
      this.fixed = names.map((name, i) => ({ name, i })).filter((o) => o.i !== this.pi);
      this.colours = [...new Set(this.vs.map((v) => v.options[this.pi]))];
      const first = this.vs.find((v) => v.available) || this.vs[0] || { options: [] };
      this.base = {}; this.fixed.forEach((o) => (this.base[o.i] = first.options[o.i]));
      this.slots = Array(this.n).fill(null); this.at = 0; this.fresh = -1;
      this.sheet = document.getElementById(this.l.sheet);
      if (this.sheet) { document.body.appendChild(this.sheet); this.sheet.addEventListener('click', (e) => this.click(e)); }
      $('[data-p-set-open]', card).addEventListener('click', (e) => this.open(e.currentTarget));
    }
    find(colour) { return this.vs.find((v) => v.options[this.pi] === colour && this.fixed.every((o) => v.options[o.i] === this.base[o.i])); }
    used(colour) { return this.slots.filter((c) => c === colour).length; }
    room(colour, except) {
      const v = this.find(colour); if (!v || !v.available) return false;
      return v.stock == null || this.used(colour) - (except === colour ? 1 : 0) < v.stock;
    }
    open(btn) {
      if (this.vs.length < 2 || !this.sheet) { // nothing to choose: the set goes straight in
        const v = this.vs[0]; if (!v) return;
        PentolaCart.add([{ id: v.id, quantity: this.n }], { button: btn }).then((ok) => ok && PentolaCart.open(btn));
        return;
      }
      // start from the size the shopper picked on the page
      this.fixed.forEach((o) => { const on = $(`[data-p-opt="${o.i}"].is-on`, this.root); if (on) this.base[o.i] = on.dataset.pVal; });
      this.refit(); this.draw(); openOverlay(this.sheet, btn);
    }
    refit() { this.slots = this.slots.map((c) => (c && this.find(c) && this.find(c).available ? c : null)); }
    next(from) {
      for (let k = 1; k <= this.n; k++) { const j = (from + k) % this.n; if (!this.slots[j]) return j; }
      return from;
    }
    click(e) {
      const t = e.target.closest('button'); if (!t || !this.sheet.contains(t)) return;
      const d = t.dataset;
      if (d.ssSlot != null) { this.at = +d.ssSlot; this.fresh = -1; }
      else if (d.ssFix != null) { this.base[+d.ssFix] = d.ssVal; this.refit(); this.fresh = -1; }
      else if (d.ssColour != null) { this.slots[this.at] = d.ssColour; this.fresh = this.at; this.at = this.next(this.at); }
      else if ('pSsAll' in d) {
        const c = this.slots[this.at] || this.slots.find(Boolean) || this.colours.find((x) => this.room(x));
        if (!c) return;
        this.slots = this.slots.map(() => null);
        for (let k = 0; k < this.n && this.room(c); k++) this.slots[k] = c;
        this.fresh = -1; this.at = this.next(this.n - 1);
      } else if ('pSsClear' in d) { this.slots = this.slots.map(() => null); this.at = 0; this.fresh = -1; }
      else if ('pSsAdd' in d) { this.add(t); return; }
      else return;
      this.draw();
    }
    draw() {
      const s = this.sheet, L = this.l, piece = L.piece;
      $('[data-p-ss-fixed]', s).innerHTML = this.fixed.map((o) => {
        const vals = [...new Set(this.vs.map((v) => v.options[o.i]))];
        return `<fieldset class="p-opt"><legend class="p-opt__h"><span class="p-lbl">${esc(o.name)}</span></legend><div class="p-sizes">${vals.map((val) => {
          const of = this.vs.filter((v) => v.options[o.i] === val), ok = of.some((v) => v.available);
          const low = Math.min(...of.map((v) => v.price));
          return `<button type="button" class="p-size${this.base[o.i] === val ? ' is-on' : ''}${ok ? '' : ' is-na'}" data-ss-fix="${o.i}" data-ss-val="${esc(val)}"${ok ? '' : ' disabled'} aria-pressed="${this.base[o.i] === val}"><b>${esc(val)}</b><small>${money(low)}</small></button>`;
        }).join('')}</div></fieldset>`;
      }).join('');
      $('[data-p-ss-slots]', s).innerHTML = this.slots.map((c, k) => {
        const v = c && this.find(c), img = v && v.featured_image && v.featured_image.src;
        return `<li><button type="button" class="p-ss__slot${k === this.at ? ' is-at' : ''}${c ? ' is-set' : ''}${k === this.fresh ? ' is-new' : ''}" data-ss-slot="${k}" aria-pressed="${k === this.at}">
          <span class="p-ss__disc">${img ? `<img src="${esc(img)}" alt="" loading="lazy">` : `<em>${k + 1}</em>`}</span>
          <span class="p-ss__n">${esc(piece)} ${k + 1}</span><span class="p-ss__c">${c ? esc(cap(c)) : '&nbsp;'}</span></button></li>`;
      }).join('');
      $('[data-p-ss-for]', s).textContent = L.lFor.replace('[n]', this.at + 1);
      $('[data-p-ss-sw]', s).innerHTML = this.colours.map((c) => {
        const v = this.find(c), img = v && v.featured_image && v.featured_image.src, k = this.used(c), on = this.slots[this.at] === c;
        const ok = on || this.room(c);
        return `<button type="button" class="p-ss__s${on ? ' is-on' : ''}" data-ss-colour="${esc(c)}"${ok ? '' : ' disabled'} aria-pressed="${on}">
          <span class="p-ss__img">${img ? `<img src="${esc(img)}" alt="" loading="lazy">` : ''}</span><span>${esc(cap(c))}</span>${k ? `<b>${k}</b>` : ''}</button>`;
      }).join('');
      const done = this.slots.filter(Boolean).length;
      const full = this.slots.reduce((a, c) => a + ((c && this.find(c)) ? this.find(c).price : 0), 0);
      const add = $('[data-p-ss-add]', s), sum = $('[data-p-ss-sum]', s);
      if (done === this.n) {
        const total = Math.round((full * (100 - this.pct)) / 100);
        sum.innerHTML = `<span>${esc(L.lTitle)} · ${money(total)}</span>${total < full ? `<s>${money(full)}</s><em>${esc(L.lSave.replace('[amount]', money(full - total)))}</em><small>${esc(L.lNote)}</small>` : ''}`;
        add.disabled = false; add.textContent = L.lAdd;
      } else {
        sum.innerHTML = `<span>${esc(L.lCount.replace('[done]', done).replace('[total]', this.n))}</span>`;
        add.disabled = true; add.textContent = L.lLeft.replace('[left]', this.n - done);
      }
    }
    async add(btn) {
      const items = [];
      this.slots.forEach((c) => { const v = this.find(c); if (!v) return; const it = items.find((x) => x.id === v.id); if (it) it.quantity += 1; else items.push({ id: v.id, quantity: 1 }); });
      if (items.reduce((a, x) => a + x.quantity, 0) !== this.n) return;
      const ok = await PentolaCart.add(items, { button: btn });
      if (!ok) return;
      closeOverlay(true);
      this.slots = this.slots.map(() => null); this.at = 0; this.fresh = -1;
      PentolaCart.open(this.card.querySelector('[data-p-set-open]'));
    }
  }
  $$('[data-p-set]').forEach((c) => new SetBuilder(c));

  /* recently viewed rail */
  $$('[data-p-recent]').forEach((box) => {
    const skip = box.dataset.pRecent;
    const list = store.get('pentola-recent', []).filter((x) => x.h !== skip).slice(0, 8);
    if (!list.length) return;
    $('[data-p-recent-list]', box).innerHTML = list.map((x) => `<li class="p-card"><div class="p-card__f"><a class="p-frame" href="${esc(x.u)}" tabindex="-1" aria-hidden="true">${x.i ? `<img src="${esc(x.i)}" alt="" loading="lazy" class="p-main">` : ''}</a></div><div class="p-card__b"><a class="p-card__t" href="${esc(x.u)}">${esc(x.t)}</a><div class="p-card__p"><span>${esc(x.p)}</span></div></div></li>`).join('');
    box.hidden = false;
  });

  /* ---------- quick view ---------- */
  const QuickView = {
    async open(url, from, swap) {
      const el = $('#PQuickView'); if (!el) return;
      if (!swap) { el.innerHTML = `<div class="p-qv__load">${esc(S.loading)}</div>`; openOverlay(el, from); }
      try {
        const u = new URL(url, location.origin); u.searchParams.set('section_id', 'pentola-quick-view');
        const html = await (await fetch(u)).text();
        const node = parse(html).querySelector('[data-p-product]');
        if (!node) throw new Error('missing');
        el.innerHTML = ''; el.appendChild(node);
        const track = $('.p-qv__m', node), dots = $$('.p-qv__n i', node);
        if (track && dots.length) track.addEventListener('scroll', () => { const i = Math.round(track.scrollLeft / track.clientWidth); dots.forEach((d, j) => d.classList.toggle('is-on', j === i)); }, { passive: true });
        new Product(node);
        el.focus({ preventScroll: true });
      } catch (e) {
        el.innerHTML = `<div class="p-qv__load"><a class="p-ul" href="${esc(url)}">${esc(S.error)}</a></div>`;
      }
    },
  };

  /* ---------- search ---------- */
  const sIn = $('#PSearchInput'), sOut = $('#PSearchResults');
  let sT, sCtl;
  async function suggest(q) {
    if (!sOut) return;
    sCtl && sCtl.abort(); sCtl = new AbortController();
    const u = new URL(P.routes.suggest, location.origin);
    u.searchParams.set('q', q); u.searchParams.set('section_id', 'pentola-predictive-search');
    u.searchParams.set('resources[type]', 'product,collection,query'); u.searchParams.set('resources[limit]', '8'); u.searchParams.set('resources[limit_scope]', 'each');
    try { const html = await (await fetch(u, { signal: sCtl.signal })).text(); const n = parse(html).querySelector('[data-p-suggest]'); sOut.innerHTML = n ? n.innerHTML : ''; } catch (e) {}
  }
  if (sIn) {
    const idle = sOut ? sOut.innerHTML : '';
    sIn.addEventListener('input', () => { clearTimeout(sT); const q = sIn.value.trim(); if (!q) { sOut.innerHTML = idle; return; } sT = setTimeout(() => suggest(q), 220); });
    document.addEventListener('click', (e) => { const s = e.target.closest('[data-p-suggestion]'); if (s) { e.preventDefault(); sIn.value = s.dataset.pSuggestion; suggest(sIn.value); } });
  }

  /* ---------- collection filters + load more ---------- */
  function bindCollection(root = document) {
    const sec = $('[data-p-collection]', root) || $('[data-p-collection]');
    if (!sec) return;
    const sid = sec.dataset.pSection;
    const go = async (url, push = true) => {
      const body = $('[data-p-cbody]'); body && body.classList.add('is-loading');
      const u = new URL(url, location.origin); u.searchParams.set('section_id', sid);
      try {
        const html = await (await fetch(u)).text();
        const fresh = parse(html).querySelector('[data-p-collection]');
        if (fresh) { sec.innerHTML = fresh.innerHTML; reveal(sec); }
        if (push) { const clean = new URL(url, location.origin); clean.searchParams.delete('section_id'); history.pushState({ p: 1 }, '', clean); }
      } catch (e) { location.href = url; }
    };
    sec.addEventListener('click', (e) => {
      const f = e.target.closest('[data-p-filter-open]');
      if (f) {
        const tpl = $('[data-p-filter-tpl]', sec), box = $('#PFilters');
        if (!tpl || !box) return;
        box.innerHTML = tpl.innerHTML;
        openOverlay(box, f);
        const form = $('form', box);
        form.addEventListener('submit', (ev) => {
          ev.preventDefault();
          const fd = new FormData(form), u = new URL(form.action, location.origin);
          for (const [k, v] of fd.entries()) if (v !== '') u.searchParams.append(k, v);
          closeOverlay(true); go(u.toString());
        });
      }
      const more = e.target.closest('[data-p-more]');
      if (more) {
        e.preventDefault(); more.classList.add('is-busy');
        const u = new URL(more.getAttribute('href'), location.origin); u.searchParams.set('section_id', sid);
        fetch(u).then((r) => r.text()).then((html) => {
          const doc = parse(html);
          const items = $$('[data-p-items] > *', doc), list = $('[data-p-items]', sec);
          items.forEach((li) => list.appendChild(li));
          const next = $('[data-p-more-wrap]', doc), wrap = $('[data-p-more-wrap]', sec);
          if (wrap) wrap.innerHTML = next ? next.innerHTML : '';
        }).catch(() => (location.href = more.href));
      }
      const clear = e.target.closest('[data-p-clear]');
      if (clear) { e.preventDefault(); go(clear.getAttribute('href')); }
    });
    addEventListener('popstate', () => go(location.href, false));
  }
  bindCollection();

  /* ---------- theme editor ---------- */
  document.addEventListener('shopify:section:load', (e) => { reveal(e.target); $$('[data-p-product]', e.target).forEach((r) => new Product(r)); $$('[data-p-tick]', e.target).forEach(newsBar); });
})();
